import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import MediaUpload from '../../../components/Business/MediaUpload'
import SettingsCard from '../../../components/Settings/SettingsCard'

export default function SponsorMarketingCard({
  imageUrl,
  onChange,
  onSave,
  hasChanged,
  isSaving,
}) {
  const { t } = useTranslation()

  return (
    <SettingsCard
      icon="bullhorn"
      title={t(
        'business.edit.sponsor_marketing_title',
        'Sponsor Banner Advertising',
      )}
      actions={
        <button
          className="btn btn-primary"
          type="button"
          onClick={onSave}
          disabled={!hasChanged || isSaving}
        >
          {isSaving
            ? t('users.edit.saving', 'Saving...')
            : t('business.edit.save')}
        </button>
      }
    >
      <MediaUpload
        imageUrl={imageUrl}
        onChange={onChange}
        label={t(
          'business.edit.sponsor_marketing_label',
          'Sponsor Banner Advertising',
        )}
      />
    </SettingsCard>
  )
}

SponsorMarketingCard.propTypes = {
  imageUrl: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  hasChanged: PropTypes.bool,
  isSaving: PropTypes.bool,
}
